import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Material
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSortModule } from '@angular/material/sort'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatBadgeModule } from '@angular/material/badge'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatChipsModule } from '@angular/material/chips'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatOptionModule } from '@angular/material/core'
import { MatSelectModule } from '@angular/material/select'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper'
import { MatMenuModule } from '@angular/material/menu'
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatRippleModule } from '@angular/material/core';
import { MatListModule } from '@angular/material/list';

import { GrantsDirective } from '../core/directives/grants.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserLookupComponent } from './components/user-lookup/user-lookup.component';
import { PersonSummaryCardComponent } from './components/person-summary-card/person-summary-card.component';
import { CertSummaryListComponent } from './components/cert-summary-list/cert-summary-list.component';
import { ApplicationListComponent } from './components/application/application-list/application-list.component';
import { ApplicationListItemComponent } from './components/application/application-list-item/application-list-item.component';
import { FormControlComponent } from './components/form/form-control/form-control.component';
import { ReadMoreComponent } from './components/read-more/read-more.component';
import { DashboardMessagesComponent } from '../views/partials/dashboard-messages/dashboard-messages.component';
import { RouterModule } from '@angular/router';
import { DashboardItemComponent } from '../views/partials/dashboard-item/dashboard-item.component';
import { FilterItemSelectComponent } from './components/filter-items/filter-item-select/filter-item-select.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatSliderModule} from '@angular/material/slider';
import { BrowserCheckComponent } from './components/general/browser-check/browser-check.component';
import { ScheduledMaintenanceComponent } from './components/general/scheduled-maintenance/scheduled-maintenance.component';
import { AppProgressComponent } from './components/application/app-progress/app-progress.component';

const matModules = [
  MatIconModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatCheckboxModule,
  MatButtonToggleModule,
  MatBadgeModule,
  MatToolbarModule,
  MatChipsModule,
  MatExpansionModule,
  MatSnackBarModule,
  MatOptionModule,
  MatSelectModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatAutocompleteModule,
  MatRadioModule,
  MatDialogModule,
  MatStepperModule,
  MatMenuModule,
  MatTabsModule,
  MatCardModule,
  MatSidenavModule,
  MatRippleModule,
  MatTooltipModule,
  MatSliderModule,
  MatListModule,
]
const coreModules = [
  FormsModule,
  ReactiveFormsModule,
]
const components = [
  GrantsDirective,
  UserLookupComponent,
  PersonSummaryCardComponent,
  CertSummaryListComponent,
  ApplicationListComponent,
  ApplicationListItemComponent,
  FormControlComponent,
  ReadMoreComponent,
  DashboardMessagesComponent,
  DashboardItemComponent,
  FilterItemSelectComponent,
  BrowserCheckComponent,
  ScheduledMaintenanceComponent,
  AppProgressComponent,
]

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    CommonModule,
    RouterModule,
    ...coreModules,
    ...matModules,
  ],
  exports: [
    ...components,
    ...coreModules,
    ...matModules,
  ]
})
export class SharedModule { }
